import backlinkApi from './backlinkNewApi';

export const backlinkInternalPage = backlinkApi.injectEndpoints({
  endpoints: build => ({
    getInternalPagesChartStats: build.query({
      query: body => ({
        url: '/api_backlink/v1/internal_pages/chart/stats',
        method: 'POST',
        body: body
      })
    }),
    getInternalPagesCount: build.query({
      query: body => ({
        url: '/api_backlink/v1/internal_pages/',
        method: 'POST',
        body: body
      })
    }),
    getInternalPages: build.mutation({
      query: body => ({
        url: '/api_backlink/v1/internal_pages/',
        method: 'POST',
        body: body
      })
    })
  })
});

export const {
  useGetInternalPagesChartStatsQuery,
  useGetInternalPagesCountQuery,
  useGetInternalPagesMutation
} = backlinkInternalPage;
export default backlinkInternalPage;
